import {CommonModule} from "@angular/common";
import {Component, OnInit} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import {
  NavController,
  NavParams,
  LoadingController,
  ToastController,
  ModalController,
  IonicModule,
} from "@ionic/angular";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import {DateFormatPipe} from "src/app/pipes/date-format/date-format";
import {ImagePipe} from "src/app/pipes/image/image";
import {SafeHtmlPipe} from "src/app/pipes/safe-html/safe-html";
import {OracaoProvider} from "src/app/services/oracao/oracao";

@Component({
  selector: "app-oracao-resposta",
  templateUrl: "./oracao-resposta.page.html",
  styleUrls: ["./oracao-resposta.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SafeHtmlPipe,
    ImagePipe,
    ReactiveFormsModule,
    SemRegistroComponent,
    LoadingSpinnerComponent,
  ],
})
export class OracaoRespostaPage implements OnInit {
  idOracao = "";
  respostas: any;
  liberado_inicial = false;
  validations_form: FormGroup;
  oracao: any;
  loaded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public oracaoProvider: OracaoProvider,
    public formBuilder: FormBuilder,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    private translate: TranslateService
  ) {
    this.oracao = this.navParams.get("oracao");
    this.idOracao = this.oracao.id;
    this.liberado_inicial = this.oracao.privacidade == "PUBLICO";

    this.validations_form = this.formBuilder.group({
      resposta: new FormControl("", Validators.required),
      liberado: new FormControl(false),
    });

    this.oracaoProvider.getResposta(this.idOracao).subscribe((data) => {
      this.respostas = data;
    });
    setTimeout(() => {
      this.loaded = true;
    }, 2000);
  }

  ngOnInit() {
  }

  validation_messages = {
    resposta: [{type: "required", message: this.translate.instant("A resposta deve ser informada")}],
  };

  public closeModal() {
    this.modalCtrl.dismiss(false);
  }

  onSubmit(oracao: {liberado: boolean; resposta: any}) {
    this.oracaoProvider
      .responder(this.idOracao, oracao.liberado, oracao.resposta)
      .subscribe(async (data) => {

        const toast = await this.toastCtrl.create({
          message: this.translate.instant("Mensagem respondida com sucesso!"),
          duration: 3000,
        });

        toast.present();

        this.modalCtrl.dismiss(data);
      });
  }

}
